import { emitServices } from "./emitServices";
import {
  TransformedDeliveryService,
  TransformedExtendedWarranty,
} from "../../types/serviceTypes";

export const toggleSelectedService = (
  serviceId: string,
  services: (TransformedDeliveryService | TransformedExtendedWarranty)[],
) => {
  const newServices = [] as (
    | TransformedDeliveryService
    | TransformedExtendedWarranty
  )[];

  for (const service of services) {
    if (service.id === serviceId) {
      newServices.push({ ...service, selected: !service.selected });
    } else {
      newServices.push(service);
    }
  }
  const selectedServices = newServices.filter((service) => service.selected);

  emitServices(selectedServices);
  return newServices;
};
